module.exports = __webpack_public_path__ + "img/gj1.e92a251a.jpg";